import api from "@/api/modules/other";

export const addLookupLog = (lookup) => {
    if(Object.keys(lookup.lookup)[0] !== 'pathMatch') {
        return api.add_lookup_log(lookup.lookup, {'raw': lookup.referrerRaw, 'params': lookup.referrerLookup})
            .then(resp => {
                // console.log('lookup added to logs--', lookup.lookup)
            })
            .catch(err => {
                console.log(err);
            })
    }
}
